// Copyright (c) Docugami, Inc. All rights reserved.
import { useAppSelector } from 'hooks/redux';
import { ComponentType, FC } from 'react';

const withOrganizationRequired = <P extends object>(
  Component: ComponentType<P>,
): FC<P> => {

  return function WithOrganizationRequired(props: P): JSX.Element {
    const curOrg = useAppSelector(state => state.organizations.currentOrganization);
    return !!curOrg?.id ? <Component {...props} /> : <></>
  };
};

export default withOrganizationRequired;